import * as React from 'react';
import { SVGProps } from 'react';

const IconVolumeUpSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.223 2.088c.23-.16.54-.095.692.146A7.053 7.053 0 0 1 11 5.999a7.055 7.055 0 0 1-1.079 3.766.485.485 0 0 1-.692.148.54.54 0 0 1-.14-.726A5.97 5.97 0 0 0 10.002 6a5.97 5.97 0 0 0-.918-3.186.54.54 0 0 1 .139-.726ZM7.916 3.509a.5.5 0 1 0-.832.553 3.5 3.5 0 0 1 .003 3.87.5.5 0 0 0 .834.553 4.5 4.5 0 0 0-.005-4.976ZM5.115 2.147 3 4H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1l2.115 1.853c.326.315.885.092.885-.353v-7c0-.445-.559-.668-.885-.353Z" />
  </svg>
);
export default IconVolumeUpSizeXs;
